// extracted by mini-css-extract-plugin
export default {"iconWrapper":"EditorEmojiPicker_iconWrapper__7pl+C","icon":"EditorEmojiPicker_icon__4fWfe","isActive":"EditorEmojiPicker_isActive__5iYAK"};